// Module
var code = "<div class=\"node-container\" data-test-id=\"node_container_{{metaObject.name}}\"> <span class=\"icon icon-flow\"></span> <span class=\"node-name\" title=\"{{metaObject.name}}\">{{metaObject.name}}</span> </div> ";
// Exports
export default code;